import { useEffect, useState, useRef } from 'react';
import { formatPrice } from '../functions/commom';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  animatedNumber: {},
});

function AnimatedNumber({
  value,
  format = 'number',
  duration = 300,
  decimalPlaces = 0,
  prefix = '',
  suffix = '',
}: {
  value: number;
  format?: 'number' | 'currency';
  duration?: number;
  decimalPlaces?: number;
  prefix?: string;
  suffix?: string;
}) {
  const [currentValue, setCurrentValue] = useState(0);
  const classes = useStyles();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const prevValueRef = useRef<number>(0);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // Start from the current value instead of 0 when value changes
    const startValue = currentValue;
    const stepAmount = (value - startValue) / (duration / 16); // ~60fps
    let current = startValue;

    prevValueRef.current = value;

    intervalRef.current = setInterval(() => {
      current += stepAmount;

      if (
        (stepAmount > 0 && current >= value) ||
        (stepAmount < 0 && current <= value) ||
        stepAmount === 0
      ) {
        setCurrentValue(value);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      } else {
        setCurrentValue(current);
      }
    }, 16);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [value, duration, currentValue]);

  return (
    <span className={classes.animatedNumber}>
      {format === 'currency'
        ? formatPrice(currentValue, prefix, decimalPlaces) + suffix
        : prefix + currentValue.toFixed(decimalPlaces) + suffix}
    </span>
  );
}

export default AnimatedNumber;
